import { IndustryPage } from './IndustryPage'
import { industriesData } from '@/data/industries'

export default function Legal() {
  return <IndustryPage industry={industriesData.legal!} />
}
